import { render, staticRenderFns } from "./studentManagementAdd.vue?vue&type=template&id=3cb39187&scoped=true&"
import script from "./studentManagementAdd.vue?vue&type=script&lang=js&"
export * from "./studentManagementAdd.vue?vue&type=script&lang=js&"
import style0 from "./studentManagementAdd.vue?vue&type=style&index=0&id=3cb39187&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb39187",
  null
  
)

export default component.exports